import app from 'flarum/forum/app';

import Component from 'flarum/common/Component';

export default class CustomImage extends Component {
  view() {
    return <div class="BHASVIC-Cover-Image" />;
  }

  static mount() {
    const container = document.getElementById('bhasvic-custom-image');

    // Fail safely if the container isn't found
    if (!container) return;

    // Mount this component to the `#bhasvic-navbar` container
    m.mount(container, CustomImage);
  }
}
